// @ts-nocheck
'use strict';
import 'whatwg-fetch';

class Naskor {

    constructor() {

    }

    static get loadingClass() {
        return 'is_loading';
    }

    static formatPrice = (price, price_currency = 'EUR', locale = 'de-DE') => {
        let formatted = '';
        if(price !== false) {
            formatted = price.toLocaleString(locale, {style: 'currency', currency: price_currency});
        }
        return formatted;
    };

    static formatWeight = (weight) => {
        let suffix = 'g';
        if(weight > 999) {
            weight = weight / 1000;
            suffix = 'kg';
            weight = Naskor.formatNumber(weight);
        }
        return `${weight} ${suffix}`;

    };

    static formatNumber = (number, decimals = 2, locale = 'de-DE') => {
        return parseFloat(number).toLocaleString(locale, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    };

    static formatDate = (date, format = 'medium' , locale = 'de-DE') => {
        if(!(date instanceof Date)) {
            date = new Date(date);
        }
        let options = {};
        // options.timeZone = "UTC"; // ETA modified to another day
        // https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString
        if(format === 'medium') {
            options.year = 'numeric';
            options.month = '2-digit';
            options.day = '2-digit';
        }
        return date.toLocaleDateString(locale, options);
    };

    static fetchJson = (url, body) => {
        let headers = new Headers();
        headers.append('X-Requested-With', 'XMLHttpRequest');
		let init = {};
        if(body) {
			init = {
				credentials: 'same-origin',
				headers: headers,
				body: body,
				method: 'POST',
			};
		} else {
			init = {
				credentials: 'same-origin',
				headers: headers,
			};
		}

        return fetch(url, init)
            .then(response => response.json())
            // .catch(data => {
            //     console.log(data);
            //     return Promise.reject(data);
            // })
            ;
    };

}

interface NaskorBrand {
    id: number;
    name: string;
}

interface NaskorCountry {
    id: number;
    name: string;
}

interface NaskorVatInfo {
    vatRate: number;
    vatFrom: number;
    vatValue: number;
}

interface NaskorShippingAddress {
    id: number;
    default: boolean;
    firstname: string;
    lastname: string;
    company: string;
    street: string;
    street2: string;
    number: string;
    zip: string;
    city: string;
    country: NaskorCountry;
}

interface NaskorBasketUser {
    defaultShippingCountry: NaskorCountry;
    shippingAddresses: NaskorShippingAddress[];
}

export {
    Naskor,
    NaskorBrand,
    NaskorCountry,
    NaskorBasketUser,
    NaskorShippingAddress,
	NaskorVatInfo,
};